module.exports = __webpack_public_path__ + "img/banner.cb41f1dc.png";